import { useEffect, useState } from 'react';
import Styles from './styles.module.scss';
import Button from '../../components/button';
import * as Yup from 'yup';
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FormInput } from "../../wrappers/formInput";
import FormHead from '../../components/headings/FromHead';
import { Auth } from 'aws-amplify';
import NotificationAlert from '../../components/notification';
import { Icon } from '@iconify/react';
import mixpanelData from '../../utils/mixpanel';
import { reset } from 'mixpanel-browser';

export type SettingFormFields = {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
};

const validationSchema = Yup.object({
  oldPassword: Yup.string().required("Field is required"),
  newPassword: Yup.string().required("Field is required"),
  confirmPassword: Yup.string()
    .required("Field is required")
    .oneOf([Yup.ref("newPassword"), null], "Passwords don't match!"),
});

function PasswordChange(props: any) {
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<SettingFormFields>(formOptions);

  const [notification, setNotification] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [togglepass1, setTogglepass1] = useState<boolean>(false)
  const [togglepass2, setTogglepass2] = useState<boolean>(false)
  const [togglepass3, setTogglepass3] = useState<boolean>(false)

  useEffect(() => {});

  const onSubmit = (data: any) => {
    if (data.oldPassword === data.newPassword) {
      setError("Old and new passwords should not be the same");
    } else {
      Auth.currentAuthenticatedUser()
        .then((user) => {
          mixpanelData('ML-Reset Password', {
            'distinct_id': localStorage.getItem('Email'),
            'email': user.attributes.email,
            'Name': user.attributes.given_name + " " + user.attributes.family_name
          })
          return Auth.changePassword(user, data.oldPassword, data.newPassword);
        })
        .then((data) => {
          setError(" ");
          setNotification(true);
          reset()
          mixpanelData('New ML - Password reset', {
            'distinct_id': localStorage.getItem('Email')
          })
          setTimeout(() => {
            setNotification(false);
         
          }, 3000);
        })
        .catch((err) => errorMessage(err.message));
    }
  };

  const errorMessage = (message: any) => {
    switch (message) {
      case "Incorrect username or password.":
        return setError(
          "Current password does not match with the existing password"
        );
      case "Password did not conform with policy: Password not long enough":
        return setError("Your new password must be at least 6 characters long");
      case "Attempt limit exceeded, please try after some time.":
        return setError(
          "You have exceeded the attempts, please try after some time	"
        );
      default:
        return setError(" ");
    }
  };

  const onClose = () => {
    setNotification(false);
  };

  return (
    <>
      {notification && (
        <NotificationAlert closable={true} onClose={onClose}>
          {" "}
          Password changed succesfully{" "}
        </NotificationAlert>
      )}
      <figure className={Styles.uploadPicWrap}>
        {props.defImage ? (
          <img alt='' src={props.defImage} />
        ) : (
          <span className={Styles.noPicWrap}>
            {props && props.companyName && props.companyName[0] + 
            props.companyName[1]}
          </span>
        )}
      </figure>
      <form>
        <FormHead>Change Password</FormHead>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Current Password</label>
            <div className='password-filed'>
            <FormInput<SettingFormFields>
              id="oldPassword"
              type={togglepass1 ? 'text' : 'password'}
              name="oldPassword"
              size="medium"
              placeholder="Enter your current password"
              register={register}
              errors={errors}
            />
            <Icon icon={togglepass1 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass1((prev) => !prev)}/>
            </div>
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">New Password</label>
            <div className='password-filed'>
            <FormInput<SettingFormFields>
              id="newPassword"
              type={togglepass2 ? 'text' : 'password'}
              name="newPassword"
              size="medium"
              placeholder="Enter your new password"
              register={register}
              errors={errors}
            />
           <Icon icon={togglepass2 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass2((prev) => !prev)}/>
            </div>
          </div>
        </div>
        <div className="half-form-wrap">
          <div className="form-group">
            <label className="lablel">Confirm Password</label>
            <div className='password-filed'>
            <FormInput<SettingFormFields>
              id="confirmPassword"
              type={togglepass3 ? 'text' : 'password'}
              name="confirmPassword"
              size="medium"
              placeholder="Repeat your new password"
              register={register}
              errors={errors}
            />
           <Icon icon={togglepass3 ? "mdi:eye-off-outline" : "mdi:eye-outline"} className='eye-icon' onClick={() => setTogglepass3((prev) => !prev)}/>
            </div>
          </div>
        </div>
        <div className="form-group">
          {error && (
            <div>
              <div className="k-form-error">{error}</div>
            </div>
          )}
        </div>
        <div className="action-form">
          <Button onClick={props.back} variant="cancel">
            {" "}
            Back
          </Button>
          <Button onClick={handleSubmit(onSubmit)} variant="primary">
            Update
          </Button>
        </div>
      </form>
    </>
  );
}
export default PasswordChange;
